import type React from 'react';
import { StyleSheet, type TextStyle } from 'react-native';

export const toHtmlTextStyle = (
    style: TextStyle | TextStyle[] | number,
    overrides: React.CSSProperties = {}
): React.CSSProperties => {
    const flattened = (StyleSheet.flatten(style as any) ?? {}) as TextStyle;
    const htmlStyle: React.CSSProperties = {
        ...(flattened as React.CSSProperties),
        ...overrides,
    };

    if (typeof flattened.lineHeight === 'number' && overrides.lineHeight === undefined) {
        htmlStyle.lineHeight = `${flattened.lineHeight}px`;
    }

    return htmlStyle;
};
